import { WaypointTableRow } from "../../core/models/path-waypoint";
import {
  KmlBuilder,
  KmlBuilderPath,
  KmlMapPointInterface,
} from "../../shared/mapping/kml/kml-builder";

export const pathIdToNumber = (pathId: string): number => {
  const lastIndex = pathId.lastIndexOf("P");
  return parseInt(pathId.substring(lastIndex + 1), 10);
};

export class PathKmlBuilder extends KmlBuilder {
  static waypointPathAsKmlBuilderPath(path: {
    pathId: string;
    mapWaypointRows: WaypointTableRow[];
  }): KmlBuilderPath {
    const pathId = path.pathId;
    const wpRows = path.mapWaypointRows;
    const points: KmlMapPointInterface[] = [];
    for (const wpRow of wpRows) {
      const wp = wpRow.mapWaypoint;
      const point = {
        id: wp.id,
        name: wp.name,
        pointId: wp.pointId,
        exPointId: wp.exPointId,
        parentId: wp.parentId,
        type: wp.type,
        latitude: wp.latitude,
        longitude: wp.longitude,
        altitudeEllipsoidMeters:
          Number(wpRow.altitudeEllipsoidMeters ?? wp.altitudeEllipsoidMeters) ??
          0,
        color: wp.color,
        disabled: wp.disabled,
      };
      if (point.latitude && point.longitude) {
        // console.log(`point: ${JSON.stringify(point)}`)
        points.push(point);
      }

      for (const extraPt of wp.miscChildren ?? []) {
        const os = extraPt.data?.os?.toLowerCase();
        const type = os
          ? `${os} ${extraPt.type?.replace(" log", "")}`
          : extraPt.type;
        const extraPoint = {
          id: `${extraPt.id}`,
          name: extraPt.data?.carrier
            ? `${extraPt.data.carrier} ${extraPt.data.os}`
            : extraPt.title,
          pointId: "",
          exPointId: "",
          parentId: point.id,
          type,
          latitude: extraPt.latitude,
          longitude: extraPt.longitude,
          altitudeEllipsoidMeters: extraPt.altitudeEllipsoidMeters ?? 0,
          color: point.color,
          disabled: point.disabled,
        };
        if (extraPoint.latitude && extraPoint.longitude) {
          points.push(extraPoint);
        }
      }
    }
    return {
      id: pathId,
      pathNumber: pathIdToNumber(pathId) ?? 0,
      floor: wpRows[0]?.floor ?? "",
      buildingId: wpRows[0]?.buildingId ?? "",
      points,
    };
  }

  constructor(
    waypointPaths:
      | { pathId: string; mapWaypointRows: WaypointTableRow[] }[]
      | undefined
  ) {
    super();
    this.paths = (
      waypointPaths?.map(PathKmlBuilder.waypointPathAsKmlBuilderPath) || []
    ).sort((a, b) => a.id.localeCompare(b.id));
  }
}
